import { defineStore } from "pinia";

export const useApproverGroups = defineStore("approverGroups", {
  state: () => ({
    groups: [],
  }),

  actions: {
    async loadGroups() {
      let groups = await window.$A.ApproverGroupService.All();
      this.groups = groups || [];
    },
  },
});
